import type { RouteRecordRaw } from 'vue-router';
import gettext from 'src/utils/gettext';

const { $gettext } = gettext;

export const statsRoutes: RouteRecordRaw[] = [
  {
    path: '',
    name: 'stats',
    redirect: { name: 'visit-stats' },
  },
  {
    path: 'visits',
    alias: $gettext('navstevy'),
    name: 'visit-stats',
    component: () => import('src/pages/stats/VisitStatsPage.vue'),
  },
  {
    path: 'Memberships',
    alias: $gettext('Permanentky'),
    name: 'ticket-stats',
    component: () => import('src/pages/stats/TicketStatsPage.vue'),
  },
  {
    path: 'finance',
    alias: $gettext('finance'),
    name: 'finance-stats',
    component: () => import('src/pages/stats/FinanceStatsPage.vue'),
  },
  {
    path: 'Physiotherapists',
    alias: $gettext('fyzioterapeuti'),
    name: 'users-stats',
    component: () => import('src/pages/stats/UsersStatsPage.vue'),
  },
];
